import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menuTop" }

import PAGE_NAME from '@web/consts/PAGE_NAME'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'MenuTop'
},
  __name: 'top',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: _unref(PAGE_NAME).HOME },
      class: "menuTop_item",
      "data-analytics": "",
      "data-analytics-element-type": "menu_top",
      "data-analytics-element-target": { name: _unref(PAGE_NAME).HOME },
      "data-analytics-element-id": _unref(PAGE_NAME).HOME,
      "data-analytics-element-name": _ctx.$t('crumb.general'),
      "exact-active-class": "-active"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('crumb.general')), 1)
      ]),
      _: 1
    }, 8, ["to", "data-analytics-element-target", "data-analytics-element-id", "data-analytics-element-name"]),
    _createVNode(_component_router_link, {
      to: { name: _unref(PAGE_NAME).SUPPORT },
      class: "menuTop_item",
      "exact-active-class": "-active",
      "data-analytics": "",
      "data-analytics-element-type": "menu_top",
      "data-analytics-element-target": { name: _unref(PAGE_NAME).SUPPORT },
      "data-analytics-element-id": _unref(PAGE_NAME).SUPPORT,
      "data-analytics-element-name": _ctx.$t('supportCenter')
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('supportCenter')), 1)
      ]),
      _: 1
    }, 8, ["to", "data-analytics-element-target", "data-analytics-element-id", "data-analytics-element-name"]),
    _createVNode(_component_router_link, {
      to: { name: _unref(PAGE_NAME).SUBSCRIPTIONS },
      class: "menuTop_item",
      "exact-active-class": "-active",
      "data-analytics": "",
      "data-analytics-element-type": "menu_top",
      "data-analytics-element-target": { name: _unref(PAGE_NAME).SUBSCRIPTIONS },
      "data-analytics-element-id": _unref(PAGE_NAME).SUBSCRIPTIONS,
      "data-analytics-element-name": _ctx.$t('Subscriptions')
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Subscriptions')), 1)
      ]),
      _: 1
    }, 8, ["to", "data-analytics-element-target", "data-analytics-element-id", "data-analytics-element-name"])
  ]))
}
}

})